export default {"src":"/_next/static/media/speed-light.37f6d222.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};